import { createApp } from 'vue'
import App from './App.vue'
import { v4 as uuidv4 } from 'uuid'
import 'virtual:svg-icons-register'
import SvgIcon from '@/pages/components/SvgIcon/index.vue'
import { setupRouter } from './router'
import { setupStore } from './store'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import 'uchuang-resource-lib/dist/style/index.css'
import '@/assets/styles/element/index.scss'
import './style.css'
import '@/styles/dialog.scss'  // 导入全局对话框样式
import { Filter, Sort } from '@element-plus/icons-vue'
import { useUserInfoStore } from '@/store/userInfo'
// 引入 Font Awesome 核心库
import { library } from '@fortawesome/fontawesome-svg-core';
// 引入 Vue 3 专用的 Font Awesome 组件
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// 引入具体的图标样式库（这里是 solid 风格）
import { fas } from '@fortawesome/free-solid-svg-icons';
import VueMatomo from 'vue-matomo'
library.add(fas)
async function init() {
  // 生成uuid
  if (!localStorage.getItem('uuid')) {
    localStorage.setItem('uuid', uuidv4())
  }
  const app = createApp(App)
  const pinia = createPinia()
  // 使用 pinia-plugin-persistedstate 插件
  pinia.use(piniaPluginPersistedstate)
  setupRouter(app)
  app.use(pinia)
//   setupStore(app)
  app.component('SvgIcon', SvgIcon)
  app.mount('#app')
  app.component('font-awesome-icon', FontAwesomeIcon);

  app.use(VueMatomo, {
    host: 'https://matomo.qtech.cn/',
    siteId: 6
  });
}

init()

window._paq.push(['trackPageView']); // 跟踪页面视图

// 监听所有点击事件 接入友盟H5-SDK
document.addEventListener('click', () => {
  // handleTrack()
})

function handleTrack() {
  const userInfoStore = useUserInfoStore()

  const { aplus_queue } = window as any
  aplus_queue.push({
    action: 'aplus.record',
    arguments: [
      'clickEvent',
      'CLK',
      {
        user_id: userInfoStore.userInfo?.user_id ?? '',
        name: userInfoStore.userInfo?.name ?? ''
      }
    ]
  })
}
